import {
  supportConversationDetailSchema,
  supportListResponseSchema,
  supportStatsSchema,
  type SupportConversationDetail,
  type SupportListResponse,
  type SupportStats,
} from '@manaro/contracts'
import { apiRequest } from '@/shared/api/client.ts'

export interface ConversationFilters {
  query?: string
  escalatedOnly?: boolean
  offset?: number
}

export function fetchConversations(
  filters: ConversationFilters,
  signal?: AbortSignal,
): Promise<SupportListResponse> {
  const params = new URLSearchParams()
  if (filters.query) params.set('q', filters.query)
  if (filters.escalatedOnly) params.set('escalated', 'true')
  if (filters.offset) params.set('offset', String(filters.offset))
  const suffix = params.size ? `?${params.toString()}` : ''

  return apiRequest(`/support/conversations${suffix}`, { schema: supportListResponseSchema, signal })
}

export const fetchConversation = (id: string, signal?: AbortSignal): Promise<SupportConversationDetail> =>
  apiRequest(`/support/conversations/${encodeURIComponent(id)}`, {
    schema: supportConversationDetailSchema,
    signal,
  })

export const fetchSupportStats = (signal?: AbortSignal): Promise<SupportStats> =>
  apiRequest('/support/stats', { schema: supportStatsSchema, signal })
